export default __webpack_public_path__ + "static/favicon-black-f42bf978cfaf2323c6e19c0b630db56c.png";